export const PASSTYPES = [
    {
        label: 'PASS_TYPE_ALL_TYPES',
        value: 0
    },
    {
        label: 'PASS_TYPE_COMP',
        value: 30
    },
    {
        label: 'PASS_TYPE_VENDOR',
        value: 20
    },
    {
        label: 'PASS_TYPE_GUEST',
        value: 10
    },
    {
        label: 'PASS_TYPE_VIP',
        value: 6
    }
]

export const PASSSTATUSES = [
    {
        label: 'DDL_ACTIVE_PASS_TYPES',
        value: 0
    },
    {
        label: 'DDL_ALL_AVAILABLE_HISTORY',
        value: 1
    }
]


